import React, { useEffect, useState } from 'react'
import { bindActionCreators } from 'redux'
import { useSearchParams } from 'react-router-dom';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Container, Row, Col } from 'react-grid-system'
import classNames from 'classnames';

import {
  darkThemeName,
  UniWorkflow,
  UniImg,
  UniOverlapGroup,
  UniOverlapButton,
  UniLocalize,
  UniConditionalRender,
} from '@unikey/unikey-commons/release/comm';

import partnerConfig from '@alias-current-partner-customizations';

import { deeplinkDomain } from '@alias-environment';

import {
  FooterContainer,
  partnerKey,
  iosAppStoreLink,
  googlePlayStoreLink,
  navConfig,
  PartnerCustomizations,
  IPartnerCustomizations,
} from '../internal';

interface IProps extends WrappedComponentProps, IPartnerCustomizations {
  history: any,
  darkModeActive: boolean
}

const RedeemContainer: React.FC<IProps>  = (props) => {

  const [queryParams, _] = useSearchParams();
  const [manualRedeemButtonLink, setManualRedeemButtonLink] = useState('');
  
  useEffect(() => { 
    // attempt an automatic redirect if the url contains a redeem token 
    // to force lazy mobile browsers to trigger the deep link
    const redeemLink = _getRedeemLocationRedirect();
    setManualRedeemButtonLink(redeemLink);
    if (redeemLink && queryParams.has('redirectAttempted')) {
      setTimeout(() => {
        window.open(`${redeemLink}&redirectAttempted=true`, "_self");
      }, 1000);
    }
  }, [])

  const _getRedeemLocationRedirect = () => {
    const redeemToken = queryParams.get('token');
    return `${deeplinkDomain}/redeem?token=${redeemToken}`;
  }


  const imgClassName = classNames('partner-logo', {
    [partnerKey]: true
  });

  return (
    <section className="access-container">

      <section className="redeem-container">
        {/* access flow should conform to max width restrictions for massive screens */}
        <Container>
          <UniImg textKey="partner logo" className={imgClassName} src={props.darkModeActive ? partnerConfig.assets.logoOnDark : partnerConfig.assets.logoOnBackground} />
          <UniWorkflow
            titleKey="redeemCredential"
            titleIcon="getApp"
            size="wider" >

            <p><UniLocalize translate="mustInstallApp" /></p>

            <p>
              <span>
                <strong><UniLocalize translate="_redeem_step1" /></strong>
              </span>
              &nbsp;
              <span>
                <UniLocalize translate="_redeem_step1Action" />
              </span>
            </p>

            <Row>
              <UniConditionalRender visible={!!iosAppStoreLink}>
                <Col xs={16} sm={12} offset={{ xs: 4, sm: 0 }}>
                  <a href={iosAppStoreLink}>
                    <UniImg textKey="downloadAppInAppStore" className="app-badge-image iOS" src="https://unikeystatic.blob.core.windows.net/assets/commercial-app/shared/app-store-badge.png" />
                  </a>
                </Col>
              </UniConditionalRender>

              <UniConditionalRender visible={!!googlePlayStoreLink}>
                <Col xs={16} sm={12} offset={{ xs: 4, sm: 0 }}>
                  <a href={googlePlayStoreLink}>
                    <UniImg textKey="downloadAppInGooglePlayStore" className="app-badge-image android" src="https://unikeystatic.blob.core.windows.net/assets/commercial-app/shared/google-play-badge.png" />
                  </a>
                </Col>
              </UniConditionalRender>
            </Row>

            <p>
              <span>
                <strong><UniLocalize translate='_redeem_step2' /></strong>
              </span>
              &nbsp;
              <span>
                <UniConditionalRender visible={!manualRedeemButtonLink}>
                  <UniLocalize translate="_redeem_step2ActionNoToken" />
                </UniConditionalRender>
                <UniConditionalRender visible={!!manualRedeemButtonLink}>
                  <a href={manualRedeemButtonLink}><UniLocalize translate="_redeem_step2ActionWithRedeemToken" /></a>
                </UniConditionalRender>
              </span>
            </p>


          </UniWorkflow>
        </Container>
      </section>
      <FooterContainer />
    </ section>
  )
}

function mapStateToProps(state: any) {
  return {
    darkModeTheme: state.portal.darkModeTheme
  };
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({

}, dispatch);

// export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RedeemContainer, { forwardRef: true }))
export default PartnerCustomizations(injectIntl(RedeemContainer), {
  componentName: 'redeem'
})
